import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Entity } from "@common/types/entity";
import { PaginatedTransactionsActionsContext } from "./PaginatedTransactionsTable.context";

export function useChangeTransactionEntity(transaction: TransactionListItem) {
    const { saveTransaction } = useContext(PaginatedTransactionsActionsContext);

    return useMutation({
        mutationFn: async (entity: Entity) => {
            const previousEntity = transaction.entity;

            if (previousEntity !== entity) {
                return await saveTransaction(transaction, {
                    entityId: entity.id,
                });
            }
        },
    });
}
